import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './Pricing799.css';

/**
 * Страница для плана Premium ($799)
 */
const Pricing799 = () => {
  const navigate = useNavigate();

  const sections = [
    { id: 'hero', label: 'Home' },
    { id: 'testimonial', label: 'About Us' },
    { id: 'legal-help', label: 'Services' },
    { id: 'success-stories', label: 'Success Stories' },
    { id: 'features', label: 'Features' }
  ];

  return (
    <div className="pricing-799-page">
      <Header sections={sections} onJoinClick={() => navigate('/contact-form')} />
      
      <main className="pricing-799-container">
        <div className="pricing-799-box">
          <div className="pricing-799-icon">⭐</div>
          <h1 className="pricing-799-title">Premium Plan Selected</h1>
          <p className="pricing-799-subtitle">
            You have selected the Premium plan for $799
          </p>
          <div className="pricing-799-details">
            <h3>Your plan includes:</h3>
            <ul>
              <li>Basic financial management recommendations</li>
              <li>Personalized assistance from our experts</li>
              <li>Detailed assistance from our lawyers</li>
              <li>Full debt negotiation service</li>
              <li>Priority customer support</li>
            </ul>
          </div>
          <button 
            className="pricing-799-button"
            onClick={() => navigate('/contact-form')}
          >
            Continue to Payment
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Pricing799;
